// SideMenuData.js
import React from 'react';
import { MessageSquare, Package, Mail, FileText, User, FilePlus, File } from 'react-feather';

const SideMenuData = [
  {
    icon: <Package />,
    label: "Dashboard",
    isActive: false,
    link: "/",
    submenuItems: [],
  },
  {
    icon: <User />,
    label: "Students",
    isActive: false,
    submenuItems: [
      { label: "Students List", link: "/students/list", isActive: false, submenuItems1: [], id: 1 },
      { label: "New Student Entry", link: "/students/new-entry", isActive: false, submenuItems1: [], id: 2 },
    ],
  },
  {
    icon: <User />,
    label: "Employees",
    isActive: false,
    submenuItems: [
      { label: "Employees List", link: "/employee/list", isActive: false, submenuItems1: [], id: 1 },
      { label: "New Employee Entry", link: "/employee/new-entry", isActive: false, submenuItems1: [], id: 2 },
    ],
  },
  {
    icon: <File />,
    label: "Accounts",
    isActive: false,
    submenuItems: [
      {
        icon: <FileText />,
        label: "Invoice",
        link: "/view-invoice",
        isActive: false,
        id: 1,
        submenuItems1: [
          { label: "View Invoice", link: "/view-invoice", isActive: false, id: 11 },
          { label: "Create Invoice", link: "/create-invoice", isActive: false, id: 12 },
        ],
      },
      {
        icon: <FilePlus />,
        label: "Receipt",
        link: "/view-receipt",
        isActive: false,
        id: 2,
        submenuItems1: [
          { label: "View Receipt", link: "/view-receipt", isActive: false, id: 21 },
          { label: "Create Receipt", link: "/create-receipt", isActive: false, id: 22 },
        ],
      },
    ],
  },
  {
    icon: <MessageSquare />,
    label: "Student Reviews",
    isActive: false,
    submenuItems: [
      { label: "View", link: "/view-reviews", isActive: false, submenuItems1: [], id: 1 },
      { label: "Insert", link: "/insert-reviews", isActive: false, submenuItems1: [], id: 2 },
    ],
  },
  {
    icon: <Mail />,
    label: "Rich text Editor",
    isActive: false,
    link: "/text-editor",
    submenuItems: [],
  },
  {
    icon: <Mail />,
    label: "PowerPoint text Editor",
    isActive: false,
    link: "/powerpoint-editor",
    submenuItems: [],
  },
  {
    icon: <MessageSquare />,
    label: "Quiz",
    isActive: false,
    submenuItems: [
      { label: "Dashboard", link: "/quiz", isActive: false, submenuItems1: [], id: 1 },
      { label: "Create Quiz", link: "/create_quiz", isActive: false, submenuItems1: [], id: 2 },
    ],
  },
];

export default SideMenuData;
